
// adds a window.SearchProps function to the iFrame, which can be used to traverse the object model within the frame -
// this is helpful for hunting down data that could potentially be gathered via editor.eval - the search will match
// any property name, function name, or property value that contains the search value
import {isDevXd} from "@Common/ui-components/debug/is-dev";

export const searchIframeObjectModel = (editor, search = "", maxLevels = 0, baseObjectName = "") => {

    if (isDevXd()) {
        console.log("CcEditor registered search Iframe object model function");
        console.log("  Call using SearchIframeObjectModel('search', maxLevels, 'object name')");
        console.log("  Example: SearchIframeObjectModel('updateGrips', 2, 'spEditor._canvas');");
        console.log("  Note: Be careful with max levels as the search has taken 30 minutes or more when going above 7 levels");
    }

    let iFrameJS = [
        "if (!window.SearchProps) {",
        "  window.SearchProps = (prop, maxLevels, obj, path, level = 0) => {",
        "    try {",
        "      if (!level) console.log('FROM IFRAME: Searching props containing \"' + prop + '\" within \"' + path + '\" for up to ' + maxLevels + ' level' + ((maxLevels === 1) ? '' : 's') + ' deep');",
        "      if (!obj || typeof obj === 'undefined') return;",
        "      for (var key in obj) {",
        "        if (level > maxLevels || key === 'cssRules' || key === 'nonChannelContainerItems' || key === 'editableItems') return;",
        "        var indent = '';",
        "        for (var i = 0; i < level; i++) { indent += ' '; }",
        "        switch (typeof obj[key]) {",
        "          case 'function':",
        "            if (key.indexOf(prop) >= 0)",
        "              console.log(indent + 'FUNC NAME at ' + path + ': ' + key);",
        "            break;",
        "          case 'object':",
        "            window.SearchProps(prop, maxLevels, obj[key], path + '.' + key, level+1);",
        "            break;",
        "          default:",
        "            if (obj[key] && obj[key].indexOf && obj[key].length < 200 && obj[key].indexOf(prop) >= 0)",
        "              console.log(indent + 'PROP VAL at ' + path + ': ' + key + ' = ' + obj[key]);",
        "            else if (key.indexOf(prop) >= 0)",
        "              console.log(indent + 'PROP KEY at ' + path + ': ' + key + ' = ' + obj[key]);",
        "        }",
        "      }",
        "      if (!level) console.log('FROM IFRAME: Completed search');",
        "    } catch (e) { /*console.log(e);*/ }",
        "  }",
        "}",
    ].join("");

    // perform the search if a search term is provided
    if (search) {
        iFrameJS += "window.SearchProps('" + search.replace(/'/g, '\\\'') + "', " + maxLevels + ", " + baseObjectName + ", '" + baseObjectName + "', 0);";
    }

    editor.eval(iFrameJS);

    window["SearchIframeObjectModel"] = (search, maxLevels, baseObject) => {
        editor.eval('window.SearchProps("' + search + '", ' + maxLevels + ', ' + baseObject + ', "' + baseObject + '", 0)');
    };

};
